import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

export const FETCH_MOST_RELEVANT_TAB_REQUEST = 'app/InboxBasePage/FETCH_MOST_RELEVANT_TAB_REQUEST';
export const FETCH_MOST_RELEVANT_TAB_SUCCESS = 'app/InboxBasePage/FETCH_MOST_RELEVANT_TAB_SUCCESS';
export const FETCH_MOST_RELEVANT_TAB_ERROR = 'app/InboxBasePage/FETCH_MOST_RELEVANT_TAB_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchError: null,
  mostRecentTab: null,
};

export default function inboxBasePageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_MOST_RELEVANT_TAB_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_MOST_RELEVANT_TAB_SUCCESS:
      return { ...state, fetchInProgress: false, mostRecentTab: payload };
    case FETCH_MOST_RELEVANT_TAB_ERROR:
      console.error(payload); // eslint-disable-line
      // Still resolve to a tab on error, so the redirect never hangs.
      return { ...state, fetchInProgress: false, fetchError: payload, mostRecentTab: 'sales' };
    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchMostRelevantTabRequest = () => ({ type: FETCH_MOST_RELEVANT_TAB_REQUEST });
const fetchMostRelevantTabSuccess = tab => ({
  type: FETCH_MOST_RELEVANT_TAB_SUCCESS,
  payload: tab,
});
const fetchMostRelevantTabError = e => ({
  type: FETCH_MOST_RELEVANT_TAB_ERROR,
  error: true,
  payload: e,
});

// ================ Thunk helpers ================ //

// Small page, sorted client-side rather than trusted from the API,
// matching the defensive pattern already used in InboxPage.duck.js.
const RECENT_TX_PAGE_SIZE = 5;

const mostRecentTransitionAt = txs => {
  const timestamps = (txs || [])
    .map(tx => tx.attributes?.lastTransitionedAt)
    .filter(Boolean)
    .map(t => new Date(t).getTime());
  return timestamps.length > 0 ? new Date(Math.max(...timestamps)) : null;
};

const latestOf = (...dates) => {
  const valid = dates.filter(Boolean);
  return valid.length > 0 ? valid.reduce((a, b) => (a > b ? a : b)) : null;
};

// ================ Thunks ================ //

export const loadData = () => (dispatch, getState, sdk) => {
  dispatch(fetchMostRelevantTabRequest());

  const apiQueryParams = only => ({
    only,
    page: 1,
    perPage: RECENT_TX_PAGE_SIZE,
    'fields.transaction': ['lastTransitionedAt'],
  });

  return Promise.all([
    dispatch(fetchCurrentUser()),
    sdk.transactions.query(apiQueryParams('sale')),
    sdk.transactions.query(apiQueryParams('order')),
  ])
    .then(([currentUser, salesResponse, ordersResponse]) => {
      const user = currentUser || getState().user.currentUser;
      const lastActivityAt = user?.attributes?.profile?.protectedData?.lastActivityAt || {};

      const salesActivityAt = latestOf(
        lastActivityAt.sales ? new Date(lastActivityAt.sales) : null,
        mostRecentTransitionAt(salesResponse.data.data)
      );
      const ordersActivityAt = latestOf(
        lastActivityAt.orders ? new Date(lastActivityAt.orders) : null,
        mostRecentTransitionAt(ordersResponse.data.data)
      );

      const tab =
        ordersActivityAt && (!salesActivityAt || ordersActivityAt > salesActivityAt)
          ? 'orders'
          : 'sales';

      dispatch(fetchMostRelevantTabSuccess(tab));
    })
    .catch(e => {
      dispatch(fetchMostRelevantTabError(storableError(e)));
    });
};
